import React, { useEffect, useRef, useState } from 'react';
import AppNavbar from '../../components/Home/Navbar';
import Footer from '../../components/Home/Footer';
import HappyCustomersSection from '../../components/Home/HappyCustomersSection';
import HowWeAreDoingIt from '../HowItWorks/HowWeAreDoingIt';
import StickyImageSection from '../HowItWorks/StickyImageSection';
import WetrackedProcess from './WetrackedProcess';
import HowItWorksSection from './HowItWorksSection';

const HowItWorks = () => {
  const sectionsRef = useRef<(HTMLDivElement | null)[]>([]);
  const [imageSrc, setImageSrc] = useState(
    'https://liftoff.io/wp-content/uploads/2022/11/Vungle-exchange-homepage-content-block.svg'
  );

  const images = [
    'https://liftoff.io/wp-content/uploads/2022/11/Vungle-exchange-homepage-content-block.svg',
    'https://liftoff.io/wp-content/uploads/2022/11/Liftoff-monetize-home-page-1.svg',
    'https://liftoff.io/wp-content/uploads/2022/10/v2.png',
    'https://liftoff.io/wp-content/uploads/2022/11/Creative-studio-home-page-content-block-2.svg',
  ];

  useEffect(() => {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const index = parseInt((entry.target as HTMLElement).dataset.index || '0');
          setImageSrc(images[index]);
        }
      });
    },
    { threshold: 0.5 }
  );

  sectionsRef.current.forEach((section) => {
    if (section) observer.observe(section);
  });

  return () => observer.disconnect();
}, []);


  return (
    <>
      {/* Top Introduction Section */}
      <AppNavbar />
   
      {/* Second Section */}
      <section className="bg-gray-100 py-16">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row items-center justify-between plr-50">
          <div className="md:text-left mb-12 md:mb-0">
            <h2 className="font-bold items-center text-center">
              HOW IT WORKS
            </h2>
            <h1 className="text-4xl lg:text-5xl font-bold leading-tight mb-4 section-title items-center text-center">
              Track every customer from ad click to sale with <span className="text-shadow underline-span">seamless precision</span>
            </h1>
            <p className="text-lg text-gray-700 mb-6 section-subtitle text-center">
              wetracked.io powers seamless ad tracking. Link each sale to its ad origin and effortlessly push data to your ad manager. See which ads to scale, which to stop, and automatically teach the algorithm to show the right ads to the right people.
            </p>
          </div>
        </div>
      </div>
    </section>

      {/* <HowWeAreDoingIt /> */}
   

      <WetrackedProcess />
      <StickyImageSection />
      <HowItWorksSection />
      <HappyCustomersSection />
      <Footer />

      {/* CTA Section */}
      {/* <section className="py-16 bg-gray-100">
        <div className="container mx-auto px-4">
          <div className="flex flex-col md:flex-row items-center justify-center md:space-x-8">
            <div className="w-full md:w-3/4 text-left">
              <h2 className="text-4xl font-extrabold mb-4 text-gray-800">
                Get started in less than 5 minutes
              </h2>
              <p className="text-lg text-gray-600">
                And reveal your store’s full potential with reliable adblock-proof ad tracking.
              </p>
            </div>
            <div className="w-full md:w-1/4 text-center">
              <button className="bg-customcolor text-white hover:bg-customcolor-dark font-bold py-3 px-6 rounded-lg shadow-md transition duration-300">
                Start 14 Days Trial
              </button>
            </div>
          </div>
        </div>
      </section> */}

      
    </>
  );
};

export default HowItWorks;
